import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { User, UserTimelines } from '@wilson/interfaces';
import { ShiftTimelineDataState } from '@wilson/shift-timeline/state';

@Pipe({
  name: 'pinUsersToTop',
  standalone: true,
})
export class PinUsersYoTopPipe implements PipeTransform {
  private readonly store = inject(Store);

  transform<T extends User | UserTimelines>(users: T[] | null): T[] {
    const clonedUsers = users ? [...users] : [];
    const userIdsToPinOnTimeline = this.store.selectSnapshot(
      ShiftTimelineDataState.userIdsToPinOnTimeline,
    );
    if (clonedUsers && userIdsToPinOnTimeline.length) {
      const usersToHighlight: T[] = [];
      userIdsToPinOnTimeline.forEach((userId) => {
        const index = clonedUsers.findIndex((user) => user.id === userId);
        if (index !== -1) {
          const [user] = clonedUsers.splice(index, 1);
          usersToHighlight.push(user);
        }
      });
      clonedUsers.unshift(...usersToHighlight);
    }
    return clonedUsers;
  }
}
